import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Divider, Skeleton } from '@mantine/core';
import { ChevronRight, CirclePlus } from 'tabler-icons-react';
import { Link } from 'react-router-dom';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import PageView from '../../common/PageView';
import PageCard from '../../common/PageCard';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppCard from '../../common/AppCard';
import AppFlexbox from '../../common/AppFlexbox';
import * as classes from '../../../styles/nestedStyles.module.css';
import { singularPluralFormat } from '../../../helpers/format';
import { useStoreBackPath } from '../../../helpers/storeHelper';

const StoreTaxSettingsView = ({ loading, ecomStore }) => {
  const { state } = useContext(StoreContext);
  const backPath = useStoreBackPath('/merchant/settings');

  return (
    <PageView backPath={backPath} title="Store taxes" width={900}>
      <PageCard>
        <AppStack>
          <AppText style={{ fontSize: 16, fontWeight: 500 }}>Sales tax</AppText>

          <AppCard radius={8} shadow="none" style={{ padding: 0 }} withBorder>
            <AppStack style={{ gap: 0 }}>
              {!ecomStore || loading || state.ecomStoreTax.loading ? (
                <>
                  <AppFlexbox
                    style={{
                      padding: 16,
                      gap: 8,
                      alignItems: 'center'
                    }}
                  >
                    <AppFlexbox
                      style={{
                        flex: 1,
                        gap: 10,
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <AppFlexbox style={{ alignItems: 'center' }}>
                        <AppStack style={{ fles: 1, gap: 5 }}>
                          <Skeleton height={14} width={150} />
                          <Skeleton height={12} width={150} />
                          <Skeleton height={12} width={150} />
                        </AppStack>
                      </AppFlexbox>
                    </AppFlexbox>
                  </AppFlexbox>
                  <Divider />
                </>
              ) : (
                state.ecomStoreTax.value
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((t) => (
                    <React.Fragment key={t.pkEcomStoreTax}>
                      <AppFlexbox
                        className={classes['hover-action-card']}
                        component={Link}
                        style={{
                          padding: 16,
                          gap: 8,
                          alignItems: 'center',
                          textDecoration: 'none',
                          color: '#000'
                        }}
                        to={`/merchant/settings/taxes/${t.pkEcomStoreTax}`}
                      >
                        <AppFlexbox
                          style={{
                            flex: 1,
                            gap: 10,
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <AppFlexbox style={{ alignItems: 'center' }}>
                            <AppStack style={{ fles: 1, gap: 0 }}>
                              <AppText
                                style={{ fontSize: 14, fontWeight: 500 }}
                              >
                                {t.name}
                              </AppText>
                              <AppText
                                style={{
                                  fontSize: 12,
                                  color: '#666'
                                }}
                              >
                                {t.taxRate}%
                              </AppText>
                              <AppText
                                style={{
                                  fontSize: 12,
                                  color: '#666'
                                }}
                              >
                                {t.ecomStoreProductTax.length > 0
                                  ? singularPluralFormat(
                                      t.ecomStoreProductTax.length,
                                      'product',
                                      'products'
                                    )
                                  : 'All products'}
                              </AppText>
                            </AppStack>
                          </AppFlexbox>

                          <ChevronRight color="#666" size={18} />
                        </AppFlexbox>
                      </AppFlexbox>
                      <Divider />
                    </React.Fragment>
                  ))
              )}

              <AppFlexbox
                className={classes['hover-action-card']}
                component={Link}
                style={{
                  padding: 16,
                  gap: 8,
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: '#000'
                }}
                to="/merchant/settings/taxes/create"
              >
                <AppStack>
                  <CirclePlus color="dodgerblue" size={22} />
                </AppStack>
                <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                  Add tax
                </AppText>
              </AppFlexbox>
            </AppStack>
          </AppCard>
        </AppStack>
      </PageCard>
    </PageView>
  );
};

StoreTaxSettingsView.propTypes = {
  ecomStore: PropTypes.object,
  loading: PropTypes.bool
};

export default StoreTaxSettingsView;
